import type { I18nLocale } from '#/i18n/types/I18nLocale';

export const localeLinkAttr = 'data-locale-link';

export function localeLinkAttributes(locale: I18nLocale) {
  return { [localeLinkAttr]: locale };
}
